var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFilterFunnel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "filter-funnel-02"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M2.6246 4.72239C1.99431 4.01796 1.67917 3.66574 1.66728 3.3664C1.65696 3.10636 1.7687 2.85643 1.96938 2.69074C2.20039 2.5 2.67301 2.5 3.61825 2.5H15.9874C16.9326 2.5 17.4052 2.5 17.6362 2.69074C17.8369 2.85643 17.9487 3.10636 17.9383 3.3664C17.9264 3.66574 17.6113 4.01796 16.981 4.72239L12.2258 10.037C12.1002 10.1774 12.0374 10.2477 11.9926 10.3276C11.9528 10.3984 11.9237 10.4747 11.906 10.554C11.8861 10.6435 11.8861 10.7377 11.8861 10.9261V15.382C11.8861 15.5449 11.8861 15.6264 11.8599 15.6969C11.8366 15.7591 11.7989 15.8149 11.7497 15.8596C11.694 15.9102 11.6184 15.9404 11.4671 16.001L8.63374 17.1343C8.32745 17.2568 8.17431 17.3181 8.05137 17.2925C7.94386 17.2702 7.84952 17.2063 7.78885 17.1148C7.71947 17.0101 7.71947 16.8452 7.71947 16.5153V10.9261C7.71947 10.7377 7.71947 10.6435 7.69958 10.554C7.68193 10.4747 7.65278 10.3984 7.61305 10.3276C7.56826 10.2477 7.50544 10.1774 7.3798 10.037L2.6246 4.72239Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterFunnel);
export default __webpack_public_path__ + "static/media/filter-funnel.fc126e144d5c22c77f282e1e559ee145.svg";
export { ForwardRef as ReactComponent };